import styles from './index.module.scss'
import clsx from 'clsx'

export interface OutlineClasses {
  /** Styles applied to the root element. */
  root: string
}

export interface OutlineProps
  extends React.FieldsetHTMLAttributes<HTMLFieldSetElement> {
  classes?: Partial<OutlineClasses>
}

export function Outline(props: OutlineProps) {
  const { classes, className } = props

  return (
    <fieldset
      aria-hidden
      className={clsx(styles.outlineRoot, classes?.root, className)}
    ></fieldset>
  )
}
